import Vue from 'vue'
import Dialog from '@/Dialog'

Vue.component('SpatzDialog', Dialog)
